/**
 * IconTile — квадратная плитка с градиентной заливкой и значком.
 * Размер плитки и значка задаются через className.
 */
import type { ReactNode } from "react";

export function IconTile({ icon, tint, className = "" }: { icon: ReactNode; tint: string; className?: string }) {
  return (
    <div className={`grid shrink-0 place-items-center rounded-xl bg-gradient-to-br ${tint} ${className}`}>
      {icon}
    </div>
  );
}
